<template>
  <div class="form-group row img-list mr-0 ml-0">
    <ul>
      <li v-for="(item, index) in imageData" :key="index">
        <a href="#popup-slider" data-toggle="modal">
          <img :src="item" alt="" />
          <span @click="removeImg(index)"><i class="bx bx-trash bx-sm"></i></span>
        </a>
      </li>
      <li>
        <div class="add-img">
          <span class="bx bx-plus text-center"></span>
          <input @input="onSelectFile" ref="fileInput" type="file" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        imageData: [],
        arrayFormData: [],
      }
    },
    methods: {
      async onSelectFile() {
        if (this.imageData.length === 10) {
          alert('Chỉ tải lên tối đa 10 ảnh')
          return
        }

        const input = this.$refs.fileInput
        const files = input.files
        const fomatUpload = ['image/jpeg', 'image/png']
        const checkFomat = fomatUpload.includes(input.files[0].type)
        if (!checkFomat) {
          alert('Định dạng ảnh không đúng')
          return
        }

        var FileSize = input.files[0].size / 1024 / 1024 // in MB

        if (FileSize > 2) {
          alert('Size ảnh quá lớn')
          return
        }

        this.formData = new FormData()
        this.formData.append('files', files[0])
        this.formData.append('folderName', 'Leads')
        this.arrayFormData.push(this.formData)
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            this.imageData.push(e.target.result)
          }
          reader.readAsDataURL(files[0])
        }
        this.$emit('addImage', this.arrayFormData)
      },
      removeImg(index) {
        this.imageData.splice(index, 1)
        this.$emit('removeImage', index)
      },
    },
  }
</script>

<style scoped></style>
